export default {
  // 工具栏
  projectRegion: '项目区域',
  selectPlaceholder: '请选择上级菜单',
  addProject: '新增项目',

  // 表格列标题
  projectName: '项目名称',
  bindCode: '绑定码',
  projectDesc: '项目描述',
  createTime: '创建时间',
  action: '操作',
  routeName: '航线名称',

  // 按钮
  deviceList: '设备列表',
  edit: '编辑',
  cancel: '取消',
  confirm: '确定',

  // 表单标签
  projectRegionLabel: '项目区域',
  projectNameLabel: '项目名称',
  projectDescLabel: '项目描述',

  // 弹窗标题
  deviceListTitle: '设备列表',
  addProjectTitle: '新增项目',
  editProjectTitle: '修改项目',

  // 确认对话框
  deleteConfirm: '是否删除',

  // 成功消息
  deleteSuccess: '删除成功',
  addSuccess: '新增成功',
  editSuccess: '修改成功',

  // 设备页面专用
  // 面包屑导航
  projectListBreadcrumb: '项目列表',
  deviceListBreadcrumb: '设备列表',
  deviceDetailsBreadcrumb: '设备详情',

  // 设备类型菜单
  aircraft: '飞行器',
  dock: '机场',
  gateway: '遥控器',

  // 表格列标题
  deviceModel: '设备型号',
  deviceSN: '设备SN',
  deviceNickname: '设备昵称',
  firmwareVersion: '固件版本',
  onlineStatus: '在线状态',
  belongProject: '所属项目',
  joinOrganizationTime: '加入组织时间',
  onlineTime: '在线时间',

  // 状态
  online: '在线',
  offline: '离线',

  // 工具提示
  confirmModify: '确认修改',
  cancelModify: '取消修改',
  deviceLog: '设备日志',
  alarmInfo: '告警信息',
  editDevice: '编辑',
  deleteDevice: '删除',

  // 确认对话框
  deleteDeviceConfirm: '确定删除设备?',
  deleteDeviceTitle: '删除设备',

  // 升级相关
  deviceUpgrade: '设备升级',
  upgradeFailed: '升级失败',
  errorCode: '错误代码',
}
